import {Component, OnDestroy, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { SecureTokenService } from '../services/secure-token.service';
import { CDSTreeService } from '../services/cds.service';

@Component({
    selector: 'app-sso-login',
    templateUrl: './sso-login.component.html',
})

export class SsoLoginComponent implements OnInit, OnDestroy {

    private routerSubscription: Subscription;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private cdsTreeService: CDSTreeService) {}

    ngOnInit() {
        this.routerSubscription = this.route.params.subscribe(async params => {
            const encodedToken = params.accessToken;
            if (!encodedToken) {
                this.router.navigate(['login'], {replaceUrl: true});
                return;
            }

            try {
                const decodedToken = decodeURIComponent(encodedToken);
                const decoded: any = jwtDecode(decodedToken);
                const now = Math.floor(Date.now() / 1000);
                const expiresIn = decoded.exp ? decoded.exp - now : undefined;
                await SecureTokenService.storeTokens(decodedToken, undefined, expiresIn);
                SecureTokenService.clearLogoutMarker();

                sessionStorage.setItem('permissions', 'read package-management');
                sessionStorage.setItem('username', decoded.email);
                sessionStorage.setItem('loginType', 'sso');
                await this.cdsTreeService.getRootId();
                const treeRoots = await this.cdsTreeService.getTreeRoots();
                sessionStorage.setItem('treeRoots', treeRoots);
                this.router.navigate(['main', 'mmodal', 'library'], {replaceUrl: true});
            } catch {
                this.router.navigate(['login'], {replaceUrl: true});
            }
        });
    }

    ngOnDestroy() {}
}
